import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "frisbuy-summary-widget__popup-button",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.66945 13.5298H4.3125L6.3801 7.54053H8.01195L10.0766 13.5298H8.71967L7.21942 8.90918H7.17263L5.66945 13.5298ZM5.58464 11.1756H8.78986V12.1641H5.58464V11.1756Z",
    fill: "var(--fr-popup-icon-primary)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.0638 7.54053V13.5298H10.7975V7.54053H12.0638Z",
    fill: "var(--fr-popup-icon-primary)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.7091 1.76416L15.0931 3.33341C15.2835 4.11161 15.8911 4.71922 16.6693 4.90962L18.2385 5.29357L16.6693 5.67752C15.8911 5.86793 15.2835 6.47553 15.0931 7.25373L14.7091 8.82298L14.3251 7.25373C14.1347 6.47553 13.5271 5.86793 12.7489 5.67752L11.1797 5.29357L12.7489 4.90962C13.5271 4.71922 14.1347 4.11161 14.3251 3.33341L14.7091 1.76416Z",
    fill: "var(--fr-popup-icon-primary)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.3502 8.82373L17.6381 10.0007C17.781 10.5843 18.2367 11.04 18.8203 11.1828L19.9972 11.4708L18.8203 11.7588C18.2367 11.9016 17.781 12.3573 17.6381 12.9409L17.3502 14.1178L17.0622 12.9409C16.9194 12.3573 16.4637 11.9016 15.8801 11.7588L14.7031 11.4708L15.8801 11.1828C16.4637 11.04 16.9194 10.5843 17.0622 10.0007L17.3502 8.82373Z",
    fill: "var(--fr-popup-icon-primary)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.11765 5.0002H3.23415C2.5849 5.00021 2.05882 5.52644 2.05882 6.17667V14.7061C2.05882 15.3558 2.58555 15.8826 3.23529 15.8826H15.8824V17.059H3.82353C2.35294 17.6473 2.05882 18.2355 0 18.2355C0.588211 17.6473 0.901858 17.0591 0.901884 15.1157C0.908722 15.1234 0.915791 15.1309 0.922564 15.1386C0.896498 14.9984 0.882353 14.8539 0.882353 14.7061V6.17667C0.882353 4.87768 1.93417 3.82374 3.23415 3.82373H9.11765V5.0002Z",
    fill: "var(--fr-popup-icon-primary)"
  })
], -1)

import { FrPopover } from "@frisbuy/frisbuy-ui-components";

interface ViewSettings {
  type: number;
  isHideFrisbuyIcon: boolean;
  trigger?: string;
  placement?: string;
  openDelay?: number;
  closeDelay?: number;
  offset?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SumPopupSection',
  props: {
    viewSettings: {}
  },
  emits: ["swipeToMarket"],
  setup(__props: any, { emit: __emit }) {

// Modules
const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FrPopover), {
    popoverWidth: 600,
    placement: props.viewSettings.placement || 'bottom',
    trigger: props.viewSettings.trigger || 'hover',
    "open-delay": props.viewSettings.openDelay || 0,
    "close-delay": props.viewSettings.closeDelay || 0,
    offset: props.viewSettings.offset || 0,
    "hide-after": 0,
    popperClass: "frisbuy-summary-widget__popup",
    popoverOffset: 10
  }, {
    reference: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["frisbuy-summary-widget", {
        'frisbuy-summary-widget--icon-hidden':
          props.viewSettings.isHideFrisbuyIcon,
      }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('swipeToMarket')))
      }, [
        _renderSlot(_ctx.$slots, "header"),
        _renderSlot(_ctx.$slots, "content"),
        _renderSlot(_ctx.$slots, "tags"),
        _renderSlot(_ctx.$slots, "ai-2"),
        _renderSlot(_ctx.$slots, "logo")
      ], 2)
    ]),
    _: 3
  }, 8, ["placement", "trigger", "open-delay", "close-delay", "offset"]))
}
}

})